import { RootState } from '@/store/types'
import {
  BoothApplicationsState, BoothApplication,
} from '@/store/applications/booths/types'
import axios from 'axios'
import { ActionTree } from 'vuex'
import _ from 'lodash'
import moment from 'moment'

const actions: ActionTree<BoothApplicationsState, RootState> = {
  /**
   * ブース変更申請取得
   *
   * @param {string} applicationId 申請ID
   */
  getBoothApplication: (
    { commit, dispatch, getters },
    { applicationId }: { applicationId: string },
  ) => axios.get(`/applications/booth/${applicationId}`).then(async ({ data }) => {
    await Promise.all([
      dispatch('getGroupById', { groupId: data.groupId }),
    ]).then(() => dispatch('fetchBooths', {
      conditions: {
        university: getters.findUniversityByCode(data.universityCode),
        campuses: [getters.findCampusByCode(data.campusCode)],
        removedPagingLimit: true,
      },
    }))

    const application: BoothApplication = {
      id: applicationId,
      type: 'booth',
      group: getters.findGroupById(data.groupId),
      fromBooth: getters.findBoothByNames({
        university: getters.findUniversityByCode(data.universityCode),
        campus: getters.findCampusByCode(data.campusCode),
        building: data.beforeBuilding,
        room: data.beforeRoomNumber,
        number: data.beforeBoothNumber,
      }),
      toBooth: getters.findBoothByNames({
        university: getters.findUniversityByCode(data.universityCode),
        campus: getters.findCampusByCode(data.campusCode),
        building: data.afterBuilding,
        room: data.afterRoomNumber,
        number: data.afterBoothNumber,
      }),
      comment: data.comment || null,
      applicant: {
        id: data.applicantId,
        name: data.applicantName,
      },
      status: data.status,
      approvedComment: _(data.events).maxBy('date')?.comment || null,
      targetTutor: getters.findTutorById(data.tutorId),
    }

    commit('gotBoothApplication', application)
  }),

  /**
   * ブース変更申請登録
   * @param context
   * @param {BoothApplication} payload 申請内容
   */
  registerBoothApplication: (
    context,
    {
      group,
      toBooth,
      comment,
    }: BoothApplication,
  ) => axios.post('/applications/booth', {
    groupId: group.id,
    building: toBooth.building,
    roomNumber: toBooth.room,
    boothNumber: toBooth.number,
    comment,
  }),
}

export default actions
